import React from 'react';
import DocumentToAccept from './DocumentToAccept';

const RegularPendingRequests = ({ regularPendingChangeRequests }) => {
  return (
    <>
      {regularPendingChangeRequests.map((req) => (
        <div key={req.id}>
          <DocumentToAccept pendingChangeRequest={req} />
        </div>
      ))}
    </>
  );
};

export default RegularPendingRequests;
